import { createSlice } from "@reduxjs/toolkit";

import { ManagementUser, getManagementUsers } from "./actions";

type ManagementUserSliceState = {
  loading: boolean;
  error: string | null;
  success: boolean;
  managementUsers: ManagementUser[];
  totalItems: number;
};

const initialState: ManagementUserSliceState = {
  loading: false,
  error: null,
  success: false,
  managementUsers: [],
  totalItems: 0,
};

const managementUserSlice = createSlice({
  name: "managementUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getManagementUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(getManagementUsers.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.managementUsers = payload?.data?.data;
      state.totalItems = payload?.data?.totalItems;
    });

    builder.addCase(getManagementUsers.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload as string;
    });
  },
});

const { reducer } = managementUserSlice;

export default reducer;
